module.exports = __webpack_public_path__ + "static/media/feel-invigorated.f0513f39.jpg";